<div class="normalScreen" style="background:white">
  <form [formGroup]="searchForm" (ngSubmit)="search()">
    <div style="margin-left:10px;margin-top:10px">

      <mat-form-field>
        <input matInput data-cy="startDateInput" 
        [matDatepicker]="startPicker" 
        [max]="maxDate" 
        placeholder="Startdatum"
        formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      
      <mat-form-field>
        <input matInput data-cy="endDateInput" 
        [matDatepicker]="endPicker" 
        [min]="startDateInput.value" 
        [max]="maxDate" 
        value="startDateInput.value"
        placeholder="Slutdatum"
        formControlName="endDate">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
      
      <mat-form-field>
        <mat-label>Flyg</mat-label>
        <input data-cy="flightNumber" matInput formControlName="flight" maxlength="15">
      </mat-form-field>
    </div>
    <div>
      <button mat-flat-button color="primary" data-cy="searchFlight" type="submit"
        style="margin-left:10px;background:#7AB800" [disabled]="!canSearch()">Sök</button>
      <button mat-flat-button color="primary" data-cy="exportFlight" type="button" (click)="export()"
        style="margin-left:10px;background:#7AB800" [disabled]="!canExportToExcel">Exportera till Excel</button>
    </div>
  </form>
  <div style="margin-left:10px;margin-top:10px" *ngIf="noMatch" class="alert alert-info">
    <label>Hittade inga matchande flyg.</label>
  </div>
  <div>
    <ngx-spinner #spinner [config]="spinnerConfig">
    </ngx-spinner>
    <div *ngFor="let report of flightReports">
      <div style="margin-left: 10px; margin-top: 20px; border-bottom: solid; border-color: #7AB800">
        <span>
          <mat-label class="flightLabel">Riktning:</mat-label>
          <mat-label class="flightInfo">{{report.flightData?.isArrival == true ? "Ankomst" : "Avgång"}}</mat-label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.flightId">
          <mat-label class="flightLabel">Flyg:</mat-label>
          <mat-label class="flightInfo">{{report.flightData?.flightId}}</mat-label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.aircraft">
          <mat-label class="flightLabel">Typ:</mat-label>
          <mat-label class="flightInfo">{{report.flightData?.aircraft}}</mat-label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.aircraftRegistration">
          <label class="flightLabel">Reg:</label>
          <label class="flightInfo">{{report.flightData?.aircraftRegistration}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.blockTime">
          <label class="flightLabel">Block tid:</label>
          <label class="flightInfo">{{report.flightData?.blockTime}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.diIndicator">
          <label class="flightLabel">DI:</label>
          <label class="flightInfo">{{report.flightData?.diIndicator}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.flightServiceType">
          <label class="flightLabel">Service typ:</label>
          <label class="flightInfo">{{report.flightData?.flightServiceType}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.gate">
          <label class="flightLabel">Gate:</label>
          <label class="flightInfo">{{report.flightData?.gate}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.stand">
          <label class="flightLabel">Stand:</label>
          <label class="flightInfo">{{report.flightData?.stand}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.pax">
          <label class="flightLabel">Pax:</label>
          <label class="flightInfo">{{report.flightData?.pax}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.isInvoiced">
          <label class="flightLabel">Faktureras:</label>
          <label class="flightInfo">{{report.flightData?.isInvoiced}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.busIsNeeded">
          <label class="flightLabel">Buss:</label>
          <label class="flightInfo">{{report.flightData?.busIsNeeded}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.scheduledTime">
          <label class="flightLabel">Planerad tid:</label>
          <label class="flightInfo">{{getTime(report.flightData?.scheduledTime)}}</label>
        </span>&nbsp;
        <span *ngIf="report.flightData?.scheduledTime">
          <label class="flightLabel">Datum:</label>
          <label class="flightInfo">{{getDate(report.flightData?.scheduledTime)}}</label>
        </span>
      </div>

      <div width="1600">
        <div [hidden]="missingActivities(report) || busy">
          <mat-expansion-panel *ngFor="let ppl of ( report.drivers ? report.drivers : [])">
            <mat-expansion-panel-header style="font-weight:bold">
              {{ppl.name}}
            </mat-expansion-panel-header>
            <ag-grid-angular style="width:400px;height:400px;margin-left:10px;margin-top:10px" #activities
              class="ag-theme-material" [enableColResize]="true" [enableFilter]=true [animateRows]="true"
              [enableSorting]="true" [rowData]="ppl.activities" [localeText]="localeText" [columnDefs]="columnDefs">
            </ag-grid-angular>
          </mat-expansion-panel>
        </div>
        <div *ngIf="missingActivities(report) && !busy && report" style="margin-top:10px">
          <a mat-list-item>Aktiviteter saknas.</a>
        </div>
      </div>
    </div>
  </div>
</div>